'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _PageNumber = require('./PageNumber');
var _PageNumber2 = _interopRequireDefault(_PageNumber);
var _footer = require('./footer.styles');
var _wavfichacertaFichacertaSharedStyles = require('@bit/wavfichacerta.fichacerta.shared-styles.rows');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var Pagination = function (_PureComponent) {
  _inherits(Pagination, _PureComponent);
  function Pagination() {
    var _ref;
    var _temp, _this, _ret;
    _classCallCheck(this, Pagination);
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Pagination.__proto__ || Object.getPrototypeOf(Pagination)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      lastPage: 1,
      firstPage: 1,
      perPage: undefined,
      allPages: _this.props.totalPages,
      search: _this.props.filter
    }, _this.changePage = function (newPage) {
      var _this$props = _this.props,
        totalPages = _this$props.totalPages,
        changePage = _this$props.changePage,
        currentPage = _this$props.currentPage;
      var lastPage = _this.state.lastPage;
      var firstPage = _this.state.firstPage;
      if (newPage !== currentPage) {
        if (newPage >= 4 && newPage < totalPages) {
          if (newPage >= totalPages - 2) {
            lastPage = totalPages;
            firstPage = totalPages - 4;
          } else {
            lastPage = newPage + 2;
            firstPage = newPage - 2;
          }
        } else if (newPage < 4 && totalPages >= 5) {
          if (newPage > 2) {
            lastPage = newPage + 2;
            firstPage = newPage - 2;
          } else {
            lastPage = 5;
            firstPage = 1;
          }
        }
        if (newPage === totalPages && totalPages >= 5) {
          lastPage = newPage;
          firstPage = newPage - 4;
        }
        _this.setState({
          lastPage: lastPage,
          firstPage: firstPage
        }, function () {
          changePage(newPage);
        });
      }
    }, _this.goToEnd = function () {
      var totalPages = _this.props.totalPages;
      _this.changePage(totalPages);
    }, _this.goToStart = function () {
      _this.changePage(1);
    }, _this.goBackward = function () {
      var currentPage = _this.props.currentPage;
      var previousPage = currentPage - 1.;
      if (previousPage >= 1) {
        _this.changePage(previousPage);
      }
    }, _this.goForward = function () {
      var _this$props2 = _this.props,
        currentPage = _this$props2.currentPage,
        totalPages = _this$props2.totalPages;
      var nextPage = currentPage + 1.;
      if (nextPage <= totalPages) {
        _this.changePage(nextPage);
      }
    }, _this.isFinalPage = function () {
      var currentPage = _this.props.currentPage;
      var allPages = _this.state.allPages;
      return currentPage === allPages;
    }, _this.isInitialPage = function () {
      var currentPage = _this.props.currentPage;
      return currentPage === 1;
    }, _this.renderNumberOfPages = function () {
      var currentPage = _this.props.currentPage;
      var _this$state = _this.state,
        lastPage = _this$state.lastPage,
        firstPage = _this$state.firstPage;
      if (lastPage !== undefined && lastPage > 0) {
        var count = firstPage;
        var pages = [];
        while (count <= lastPage) {
          pages.push(_react2.default.createElement(_PageNumber2.default, {
            num: count,
            currentPage: currentPage,
            onClick: _this.changePage
          }));
          count++;
        }
        return pages;
      }
      return null;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }
  _createClass(Pagination, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(_footer.PaginationCol, null, _react2.default.createElement(_wavfichacertaFichacertaSharedStyles.StyledRow, {
        justify: 'flex-end'
      }, _react2.default.createElement(_footer.BoundaryClickableContainer, {
        visible: !this.isInitialPage(),
        onClick: this.goToStart,
        justify: 'flex-start'
      }, _react2.default.createElement(_footer.BoundaryContent, {
        margin: {
          right: '10px'
        }
      }, "\u3008", _react2.default.createElement(_footer.BoundaryTitle, {
        margin: {
          left: '5px'
        }
      }, 'Primeira'))), _react2.default.createElement(_footer.PaginationContent, null, _react2.default.createElement(_footer.PaginationClickableContainer, {
        visible: !this.isInitialPage(),
        onClick: this.goBackward,
        margin: {
          right: '10px'
        }
      }, _react2.default.createElement(_footer.PaginationClickableContent, null, "\u3008")), this.renderNumberOfPages(), _react2.default.createElement(_footer.PaginationClickableContainer, {
        visible: !this.isFinalPage(),
        onClick: this.goForward,
        margin: {
          left: '10px'
        }
      }, _react2.default.createElement(_footer.PaginationClickableContent, null, "\u3009"))), _react2.default.createElement(_footer.BoundaryClickableContainer, {
        visible: !this.isFinalPage(),
        onClick: this.goToEnd,
        justify: 'flex-end'
      }, _react2.default.createElement(_footer.BoundaryContent, {
        margin: {
          left: '5px'
        }
      }, _react2.default.createElement(_footer.BoundaryTitle, {
        margin: {
          right: '5px'
        }
      }, '\xDAltima'), "\u3009"))));
    }
  }], [{
    key: 'getDerivedStateFromProps',
    value: function getDerivedStateFromProps(nextProps, prevState) {
      var totalPages = nextProps.totalPages,
        resultsPerPage = nextProps.resultsPerPage,
        currentPage = nextProps.currentPage,
        filter = nextProps.filter;
      var perPage = prevState.perPage,
        allPages = prevState.allPages,
        search = prevState.search;
      if (currentPage === 1) {
        if (resultsPerPage !== perPage || allPages !== totalPages) {
          return {
            firstPage: 1,
            lastPage: totalPages >= 5 ? 5 : totalPages,
            perPage: resultsPerPage,
            allPages: totalPages
          };
        }
        if (search !== filter) {
          return {
            firstPage: 1,
            lastPage: totalPages >= 5 ? 5 : totalPages,
            perPage: resultsPerPage,
            search: filter
          };
        }
        return null;
      }
      return null;
    }
  }]);
  return Pagination;
}(_react.PureComponent);
exports.default = Pagination;